import { GTM } from './gtm.js';
import DebugHelper from '../../../scripts/helpers/debug-helper.js';

export const GTM_DE = {
	getLogger() {
		return new DebugHelper('GTM');
	},

	openSlideshow(payload) {
		GTM.trackEvent({
			event: 'open-slideshow',
			pageType: 'slideshow',
			slideshowTitle: payload.slideshowTitle,
			parentPost: payload.parentPost,
		});
	},

	openSlideshowSlide(payload) {
		GTM.trackEvent({
			event: 'open-slideshow-slide',
			pagetype: 'slideshow',
			slideshowTitle: payload.slideshowTitle,
			parentPost: payload.parentPost,
			slideTitle: payload.slideTitle,
		});
	},

	sendSubscriptionState(payload) {
		GTM.trackEvent(
			{
				event: 'subscription-status-change',
				isSubscribed: payload.isSubscribed,
			},
			true,
		);
	},
};
